module.exports = __webpack_public_path__ + "images/emoji/smirk_cat.fbd59e1f25b88e94ff60.png";